'use client';

import type { Connector } from '@repo/api-gw-sdk';
import { useCallback } from 'react';

import { DeleteEntityDialog } from '@/components/lakehouse/deleteEntityDialog';
import { useDAL } from '@/contexts/useDAL';

interface DeleteConnectorDialogProps {
  connector: Connector;
  workspaceId: string;
  open: boolean;
  onClose: () => void;
  onDeleted: () => void;
}

export const DeleteConnectorDialog = ({
  connector,
  workspaceId,
  open,
  onClose,
  onDeleted,
}: DeleteConnectorDialogProps) => {
  const dal = useDAL();

  const handleDelete = useCallback(async () => {
    await dal.lakehouse.deleteConnector(workspaceId, connector.id);
    onDeleted();
  }, [dal, workspaceId, connector.id, onDeleted]);

  return (
    <DeleteEntityDialog
      open={open}
      title='Delete Connector'
      entityLabel='connector'
      entityName={connector.name}
      warning='This will also delete all catalogs associated with this connector. This action cannot be undone.'
      onClose={onClose}
      onDelete={handleDelete}
      testIdPrefix='confirm-delete-connector'
    />
  );
};
